import { Button, Container, Icons, Row, Typography } from "@ster/ster-toolkit";
import { Col } from "antd";
import { useRecoilState } from "recoil";

import { mediumState } from "./atoms";
import styles from "./Medium.module.less";

const Medium = (): JSX.Element => {
  const [_, setMedium] = useRecoilState(mediumState);

  return (
    <Container className={styles.container}>
      <Row>
        <Col>
          <Typography.Paragraph>
            Maak je keuze voor televisie of radio.
          </Typography.Paragraph>
        </Col>
      </Row>
      <Row gutter={24} className={styles.row}>
        <Col>
          <article className={styles.packageCard}>
            <Typography.Title level={3}>Televisie</Typography.Title>
            <p className={styles.text}>
              <Icons.TVIcon />
            </p>
            <Button mode="tertiary" onClick={() => setMedium("tv")}>
              Vergelijk tv-campagnes
            </Button>
          </article>
        </Col>
        <Col>
          <article className={styles.packageCard}>
            <Typography.Title level={3}>Radio</Typography.Title>
            <p className={styles.text}>
              <Icons.RadioIcon />
            </p>
            <Button mode="tertiary" onClick={() => setMedium("radio")}>
              Vergelijk radiocampagnes
            </Button>
          </article>
        </Col>
      </Row>
    </Container>
  );
};

export default Medium;
